export default __webpack_public_path__ + "static/front_bright-a5539553fff34be826bb08dfe87c378c.png";